import PropTypes from "prop-types"
import AddressShape from "./AddressShape"


const BankAccountShape = PropTypes.shape({
  id: PropTypes.string,
  createdAt: PropTypes.string,
  accountType: PropTypes.string,
  accountNumber: PropTypes.string.isRequired,
  routingNumber: PropTypes.string.isRequired,
  beneficiaryName: PropTypes.string.isRequired,
  beneficiaryAddress: AddressShape.isRequired,
  bankName: PropTypes.string.isRequired,
  bankAddress: AddressShape.isRequired,
  bankCodeName: PropTypes.string.isRequired,
  sourceId: PropTypes.string,
  sourceName: PropTypes.string,
  isSourceVerified: PropTypes.bool,
})

export default BankAccountShape
